export default () => ({
  dashboard: {},
  overview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  filters: {
    keyword: "",
    advanced: {
      name: null,
      foundWay: null,
      status: null,
      company: [],
      date: [],
      workingHours: null,
      parentLocation: null,
      location: null,
      contractType: null,
      workingShifts: null,
      workWeekSchedule: null,
      salaryRange: null,
      previousExperience: null,
      gender: null,
      age: null,
      drivingLicense: null,
      offersTraining: null,
      contactWhatsapp: null,
      openToPwD: null,
      offersTransportation: null,
      responsible: null,
      branch: null,
    },
  },
});
